module.exports = __webpack_public_path__ + "img/profile-mobile.86c93756.png";